import { useEffect } from 'react';
import { useFormState, useWatch } from 'react-hook-form';
import { useLocation } from 'react-router-dom';
import { InvoiceDiscrepanciesServiceSingleton } from '.';
import { ConfigItem } from './types';

/**
 * Hook for managing document-level errors with UI configuration.
 * Organizes errors according to the UI configuration.
 */
export const useDiscrepancies = <TSection extends ConfigItem>(uiConfig: Array<TSection> | undefined) => {
  const formState = useFormState();
  const formData = useWatch();
  useEffect(() => {
    InvoiceDiscrepanciesServiceSingleton.processDocumentDiscrepancies(formState.errors, formData || {}, uiConfig);
  }, [formData, formState, uiConfig]);
};

/**
 * Hook for focusing on an error when a component mounts, typically used
 * after navigation to a page with errors.
 */
export const useFocusErrorOnMount = () => {
  const location: { state?: { focusOnField?: { id: string } } } = useLocation();
  const { focusOnField } = location.state || {};

  useEffect(() => {
    if (focusOnField?.id) {
      const error = InvoiceDiscrepanciesServiceSingleton.getErrorById(focusOnField.id);
      if (error) {
        InvoiceDiscrepanciesServiceSingleton.setCurrentError(error);
      }
    }
  }, [focusOnField]);
};
